import React, { FC, useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

import { fontSizeAndHeight } from '../../../styleHelpers/fontSizes';
import { colorStack } from '../../../styleHelpers/colors';
const sideToSide = keyframes`
    0%, 100% {
        transform: translateX(-50%);
    }

    50% {
        transform: translateX(150%);
    }
`;

const SLoadingStepContent = styled.div`
    width: 100%;
    height: 100%;
    min-height: 40vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
`;

const SLogo = styled.img`
    width: 90px;
`;

const SLoader = styled.div`
    height: 6px;
    margin-top: 1.5rem;
    overflow: hidden;
    position: relative;
    width: 120px;
    border-radius: 2px;
`;

const SBar = styled.div`
    animation: ${sideToSide} 2s ease-in-out infinite;
    background: linear-gradient(to right, ${colorStack.darkBlue} 0%, ${colorStack.lightBlue} 100%);
    position: absolute;
    height: 100%;
    width: 50%;
    border-radius: 2px;
`;

const SLoadingStepText = styled.div`
    margin-top: 1rem;
    ${fontSizeAndHeight[16]};
    color: ${colorStack.content};
`;

export interface ILoadingStepProps {
    isVisible: boolean;
    intervalMs: number;
    texts: string[];
}

export const LoadingStep: FC<React.PropsWithChildren<ILoadingStepProps>> = ({ isVisible, intervalMs, texts }) => {
    const [textIndex, setTextIndex] = useState<number>(0);
    const hasTexts = !!texts?.length;

    useEffect(() => {
        if (!isVisible || !hasTexts || intervalMs <= 0) {
            return;
        }

        setTextIndex(0);
        const timer = setInterval(() => {
            setTextIndex((previousValue) => {
                if (previousValue >= texts.length - 1) {
                    return previousValue;
                }
                return previousValue + 1;
            });
        }, intervalMs);

        return () => {
            clearInterval(timer);
        };
    }, [isVisible, hasTexts, intervalMs, texts]);

    if (!isVisible) {
        return null;
    }

    return (
        <SLoadingStepContent>
            <SLogo src={require('../../../../wwwroot/assets/images/LegalCluster-PrimaryBlue-OnlyRainbowStar.png')} />
            <SLoader>
                <SBar />
            </SLoader>
            {hasTexts && (
                <SLoadingStepText>{texts[Math.min(textIndex, texts.length - 1)]}</SLoadingStepText>
            )}
        </SLoadingStepContent>
    );
};
